import { render } from "./Pedido_PedidoDet.vue?vue&type=template&id=f761e1d6&scoped=true"
import script from "./Pedido_PedidoDet.vue?vue&type=script&lang=js"
export * from "./Pedido_PedidoDet.vue?vue&type=script&lang=js"

import "@/assets/css/interruptor.css?vue&type=style&index=0&id=f761e1d6&scoped=true&lang=css"
import "@/assets/css/microfono.css?vue&type=style&index=1&id=f761e1d6&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f761e1d6"]])

export default __exports__